import React, { useMemo, useState } from "react";

const FieldHint = ({ text }) => {
  const [open, setOpen] = useState(false);

  const hintId = useMemo(
    () => `field-hint-${Math.random().toString(36).slice(2, 10)}`,
    []
  );

  return (
    <span
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        marginLeft: "6px",
      }}
    >
      <button
        type="button"
        aria-label="Show field hint"
        aria-describedby={open ? hintId : undefined}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((prev) => !prev)}
        style={{
          width: "18px",
          height: "18px",
          borderRadius: "999px",
          border: "1px solid #cbd5e1",
          background: "#ffffff",
          color: "#475569",
          fontSize: "11px",
          fontWeight: "700",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          lineHeight: 1,
        }}
      >
        ?
      </button>

      {open && (
        <div
          id={hintId}
          role="tooltip"
          style={{
            position: "absolute",
            top: "26px",
            left: 0,
            zIndex: 20,
            width: "240px",
            padding: "10px 12px",
            borderRadius: "10px",
            background: "#0f172a",
            color: "#f8fafc",
            fontSize: "12px",
            lineHeight: "1.5",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.25)",
          }}
        >
          {text}
        </div>
      )}
    </span>
  );
};

export default FieldHint;